<template>
  <Order ref="order" />
  <nav-bar/>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component :is="Component" v-if="$route.meta.keepAlive"></component>
    </keep-alive>
    <component :is="Component" v-if="!$route.meta.keepAlive"></component>
  </router-view>
  <div class="subscribe" @click="openOrder">
    <span class="bgColor2">现在预定</span>
  </div>
  <div class="subscribe2">
    <span class="bgColor2"><span>服务监督热线</span><span>13818054297</span></span>
  </div>
  <Footer />
</template>

<script>
import Footer from 'components/Footer.vue'
import NavBar from './components/NavBar.vue'
import Order from './components/Order.vue'

export default {
  components: { Footer, NavBar, Order },
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  },
  methods: {
    openOrder () {
      this.$refs.order.open()
    }
  }
}
</script>

<style scoped lang="scss">
html, body {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}
.subscribe {
  position: fixed;
  right: 0;
  top: 25%;
  cursor: pointer;
  z-index: 5;
  span {
    display: block;
    text-align: center;
    padding: 35px 20px;
    width: 100px;
    font-size: 17px;
    font-weight: bold;
    letter-spacing: 4px;
    color: #fff;
  }
}
.subscribe2 {
  position: fixed;
  right: 0;
  top: 45%;
  cursor: pointer;
  z-index: 5;
  span {
    display: block;
    text-align: center;
    padding: 15px 0px;
    width: 100px;
    font-size:13px;
    font-weight: bold;
    color: #fff;
  }
}
@media screen and (max-width: 1000px) {
  .subscribe {
    span {
      width: 40px;
      padding: 20px 10px;
      font-size: 15px;
    }
  }
  .subscribe2 {
    display: none;
  }
}
</style>
